import React, { useCallback, useEffect, useState } from "react";
import { ArrowDown2, ArrowUp2, MessageQuestion } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { useContent, FaqItem } from "../../hooks/content";

import {
  Answer,
  Body,
  EmptyState,
  FaqCard,
  QuestionButton,
  QuestionRow,
  QuestionText,
} from "./styles";

const UserFAQ: React.FC = () => {
  const { listFaq } = useContent();
  const [items, setItems] = useState<FaqItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await listFaq();
      setItems(
        [...data].sort((a, b) =>
          (a.title || "").localeCompare(b.title || "", "pt-BR")
        )
      );
    } catch (error) {
      console.error(error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [listFaq]);

  useEffect(() => {
    load();
  }, [load]);

  const toggle = (uid: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(uid)) next.delete(uid);
      else next.add(uid);
      return next;
    });
  };

  return (
    <MobileLayout
      headerTitle="Perguntas frequentes"
      headerType="private"
      headerDescription="Dúvidas comuns sobre o Bilíngua"
    >
      <Body>
        {loading && (
          <p style={{ textAlign: "center", color: "#64748B" }}>Carregando...</p>
        )}

        {!loading && items.length === 0 && (
          <EmptyState>
            <MessageQuestion size={48} color="#6E6A7C" variant="Linear" />
            <h2>Nenhuma pergunta disponível</h2>
            <p>Em breve publicaremos respostas para as dúvidas mais comuns.</p>
          </EmptyState>
        )}

        {!loading &&
          items.map((item) => {
            const isOpen = expanded.has(item.uid);
            return (
              <FaqCard key={item.uid}>
                <QuestionButton
                  type="button"
                  onClick={() => toggle(item.uid)}
                  aria-expanded={isOpen}
                >
                  <QuestionRow>
                    <QuestionText>{item.title}</QuestionText>
                    {isOpen ? (
                      <ArrowUp2 size={22} color="#5F33E1" />
                    ) : (
                      <ArrowDown2 size={22} color="#5F33E1" />
                    )}
                  </QuestionRow>
                </QuestionButton>
                {isOpen && <Answer>{item.answer || item.description}</Answer>}
              </FaqCard>
            );
          })}
      </Body>
    </MobileLayout>
  );
};

export default UserFAQ;
